/**
 * Sorts indicator cards based on the indicator group name
 * @param groupName - The name of the indicator group
 * @param block - The block containing indicator group data
 * @returns Sorted array of indicators
 */
export function sortIndicatorCardsBasedOnIndicatorGroup(groupName, block) {
  const pick = (subs) => {
    const arr = [];
    for (const s of subs) {
      const val = block.indicatorGroup.find((el) => el.name.includes(s));
      if (val) arr.push(val);
    }
    return arr;
  };

  switch (groupName) {
    case "Address":
      return pick([
        "Chest Turn",
        "Pelvis Turn",
        "Chest Bend",
        "Chest Side Bend",
        "Pelvis Side Bend",
      ]);
    case "Contributions":
      return pick(["Legs", "Core", "Shoulder", "Wrist"]);
    case "Gain Factors":
      return pick(["Core", "Shoulder", "Wrist", "Release"]);
    case "Horizontals":
      return pick(["Chest", "Pelvis"]);
    case "Impact":
      return pick([
        "Chest Turn",
        "Pelvis Turn",
        "Chest Bend",
        "Chest Side Bend",
        "Pelvis Side Bend",
        "Sway Gap",
        "Chest Sway",
        "Pelvis Sway",
        "Chest Lift",
        "Pelvis Lift",
        "Hand Sway",
        "Hand Lift",
      ]);
    case "Release":
      return pick(["Angle", "Release", "Gain"]);
    case "Rotational ROM":
      return pick(["Chest", "Pelvis", "X-Factor"]);
    case "Rotational Speed":
      return pick(["Pelvis", "Chest", "Arm", "Shaft"]);
    case "Top of Backswing":
      return pick([
        "Chest Turn",
        "Pelvis Turn",
        "Chest Bend",
        "Chest Side Bend",
        "Pelvis Side Bend",
        "Sway Gap",
        "Chest Sway",
        "Pelvis Sway",
        "Chest Lift",
        "Pelvis Lift",
        "Hand Sway",
        "Hand Lift",
      ]);
    case "Transition":
      return pick(["Pelvis", "Chest", "Arm", "Tempo"]);
    case "Verticals":
      return pick(["Drop", "Lift"]);
    default:
      return block.indicatorGroup;
  }
}
